import { render } from "./AddCompanySheet.vue?vue&type=template&id=d5e989fe&ts=true"
import script from "./AddCompanySheet.vue?vue&type=script&lang=ts"
export * from "./AddCompanySheet.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__